import axios from 'axios';

// 1. Création de l'instance de base
const apiClient = axios.create({
  baseURL: 'https://werhealth-api.wer.sn/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// 2. Intercepteurs (Authentification & Sécurité)
apiClient.interceptors.request.use(
  (config) => {
    // Vérification du token dans le localStorage (priorité au nom 'token')
    const token = localStorage.getItem('token') || localStorage.getItem('user_token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("Session expirée ou Token invalide");
      localStorage.removeItem('token'); 
      localStorage.removeItem('user_token');
      localStorage.removeItem('user');
    }
    return Promise.reject(error);
  }
);
// --- SERVICE DASHBOARD ENTREPRISE ---
// --- SERVICE DASHBOARD ---
export const dashboardService = {
  // Dashboard pour les Entreprises
  getEnterpriseData(partenaireId) {
    if (!partenaireId) {
      return Promise.reject(new Error("ID Partenaire non fourni"));
    }
    return apiClient.get(`/dashboard/entreprise/${partenaireId}`);
  },

  // NOUVEAU : Dashboard pour les Hôpitaux et Pharmacies
  getHospitalData(partenaireId) {
    if (!partenaireId) {
      return Promise.reject(new Error("ID Partenaire (Hôpital/Pharma) non fourni"));
    }
    return apiClient.get(`/dashboard/pharmacie-hopital/${partenaireId}`);
  },
  getUserDashboard(userId) {
    if (!userId) return Promise.reject(new Error("ID Utilisateur non fourni"));
    return apiClient.get(`/dashboard/user/${userId}`);
  },
  getAyantDroitDashboard(id) {
  if (!id) return Promise.reject(new Error("ID Ayant-Droit manquant"));
  return apiClient.get(`/dashboard/ayantDroit/${id}`);
},

  // Rappel : contrat est de type file
  updateContrat(partenaireId, file) {
    const formData = new FormData();
    formData.append('contrat', file); 

    return apiClient.post(`/dashboard/entreprise/${partenaireId}/contrat`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};
// 3. Services API

// --- SERVICE AYANTS-DROITS (BÉNÉFICIAIRES) ---
export const ayantDroitService = {
  // On récupère les ayants-droits rattachés à un titulaire spécifique
  getByTitulaire(titulaireId) {
    return apiClient.get(`/titulaires/${titulaireId}/ayants-droits`);
  },
  
  // La création reste en POST sur la route racine
  create(data) {
    return apiClient.post('/ayants-droits', data);
  }
};
export const individuelService = {
  getAll() {
    return apiClient.get('/individuels');
  },
  getById(id) {
    return apiClient.get(`/individuels/${id}`);
  },
  create(data) {
    return apiClient.post('/individuels', data);
  },
  activate(id, formData) {
    return apiClient.post(`/admin/individuels/${id}/activation`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  updateStatus(formData) {
    return apiClient.post('/individuels/verify-documents', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

export const partenaireService = {
  getAll() {
    return apiClient.get('/partenaires');
  },
  create(formData) {
    return apiClient.post('/partenaires', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

export const employeService = {
  getAll(partenaireId) {
    return apiClient.get(`/partenaires/${partenaireId}/employes`);
  },
  create(partenaireId, formData) {
    return apiClient.post(`/partenaires/${partenaireId}/employes`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

export const authService = {
  requestOtp(email) {
    return apiClient.post('/auth/send-otp-register', { 
      email: email,
      change_password: true 
    });
  },
  resetPassword(data) {
    return apiClient.post('/forgot-password', {
      email: data.email,
      otp: data.otp,
      password: data.password,
      password_confirmation: data.password_confirmation
    });
  },
  sendOtpRegister(email) {
    return apiClient.post('/auth/send-otp-register', { email });
  }
};

export const offreService = {
  getAll() {
    return apiClient.get('/offres');
  },
  create(data) {
    return apiClient.post('/offres', data);
  },
  subscribe(data) {
    return apiClient.post('/contrats', data); 
  }
};

export const souscriptionService = {
  getAll() {
    return apiClient.get('/contrats');
  }
};

// --- SERVICE PAIEMENTS ---
// --- SERVICE PAIEMENTS MIS À JOUR ---
export const paymentService = {
  // Liste toutes les méthodes disponibles (Général)
  getAll() {
    return apiClient.get('/payment-methods');
  },

  // Création d'une méthode (Admin/Système)
  create(formData) {
    return apiClient.post('/payment-methods', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // NOUVEAU : Supprimer une méthode de paiement par son ID
  delete(id) {
    return apiClient.delete(`/payment-method/${id}`);
  },

  // NOUVEAU : Modifier une méthode de paiement
  // Note : On utilise l'endpoint spécifique /change comme demandé
  update(data) {
    return apiClient.put('/payment-method/change', data);
  },

  // --- PARTIE UTILISATEUR ---

  // Création méthode pour un utilisateur spécifique
  createUserPayment(data) {
    return apiClient.post('/user-payment-methods', data);
  },

  // NOUVEAU : Lister les choix de paiement d'un utilisateur
  // Dans votre fichier service
getUserPayments(params) {
  // params peut être { partenaire_id: '...' } ou { user_id: '...' }
  return apiClient.get('/choice-paiement', { params });
}
};

export const consultationService = {
    getConsultations() {
        return apiClient.get('/consultations');
    },

    /**
     * Créer une nouvelle consultation
     * Le champ 'contrat' est inclus dans le formData.
     * On laisse Axios gérer le header multipart automatiquement.
     */
    createConsultation(formData) {
        return apiClient.post('/consultations', formData);
    },

    checkConsultation(payload) {
        return apiClient.post('/consultations/check', payload);
    },

    getConsultationsByCarte(carteId) {
        return apiClient.get(`/consultations/carte/${carteId}`);
    },

    getConsultationDetails(id) {
        return apiClient.get(`/consultations/${id}`);
    }
};

export const serviceMedicalService = {
  getAll() {
    return apiClient.get('/services');
  },
  create(data) {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    });
    return apiClient.post('/services', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  delete(id) {
    return apiClient.delete(`/services/${id}`);
  }
};

export default apiClient;